import { useCallback, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { getUMInfoWithDesktopAndMobile } from '@utils/LoginProcess/requests';
import { useSiteInfo } from '@contexts/SiteInfoContext';
import getIsUnderMaintenance from '../utils/getUnderMaintenance';

const useRefreshData = (initUnderMaintenanceInfo, refreshTime = 60000) => {
    const router = useRouter();
    const { locale } = useRouter();
    const { siteId, clientApiUrl } = useSiteInfo();
    const [isUnderMaintenance, setIsUnderMaintenance] = useState(getIsUnderMaintenance(initUnderMaintenanceInfo));

    const checkMaintenanceStatus = useCallback(() => {
        getUMInfoWithDesktopAndMobile(clientApiUrl, siteId).then((data) => {
            setIsUnderMaintenance(getIsUnderMaintenance(data));
        }).catch((error) => console.error(error));

        const isUmPage = router.pathname === '/underMaintenance';
        if (isUnderMaintenance && !isUmPage) {
            router.push(`/${locale}/underMaintenance`);
        } else if (!isUnderMaintenance && isUmPage) {
            router.replace('/');
        }
    }, [isUnderMaintenance, locale, router, siteId]);

    useEffect(() => {
        const refreshInterval = setInterval(checkMaintenanceStatus, refreshTime);
        const stopRefreshInterval = () => {
            clearInterval(refreshInterval);
        };

        return (() => {
            stopRefreshInterval();
        });
    }, [checkMaintenanceStatus, refreshTime]);
};

export default useRefreshData;
